import React from 'react';
import utils from '../../../utils';
import fetch from '../../fetch';

import { Modal, message, Radio, Checkbox, Input, Select } from 'antd';


const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const headers = utils.columns(
    [
        {   
            key:'$index', 
            label: '序号',
            width: 80
        },
        {
            key: 'batchNo',
            label: '批次',
            width: 150
        },
        {
            key: 'objectTypeName',
            label: '对象类型',
            width: 120
        },
        {
            key: 'objectName',
            label: '对象名称',
            width: 150
        },
        {
            key:'orgName', 
            label: '部门',
            width: 150
        },
        {
            key: 'surveyName',
            label: '问卷名称',
            width: 170
        },
        {
            key:'studentNo', 
            label: '学号',
            width: 100
        },
        {
            key: 'studentName',
            label:  '姓名',
            width: 100
        },
        {
            key: 'resultScore',
            label:  '分数',
            width: 80
        },
        {
            key: 'classesName',
            label:  '班级',
            width: 100
        },
        {
            key: 'classGrade',
            label:  '年级',
        },
        {
            key: 'evalTime',
            label: '提交时间',
            width: 150
        },
        {
            key: 'termName',
            label: '所属学期/学年'
        }
    ]
)

const detailColumns = [
    {
        title: '问题',
        dataIndex: 'name',
        key: 'name',
        width: 250
    },
    {
        title: '题型',
        dataIndex: 'type',
        key: 'type',
        width: 80,
        render: (type) => {
            const typeObj = {
                options: '单选',
                multiple: '多选',
                text: '问答',
                moreinput: '填空',
                select: '下拉',
                belong: '附属'
            }
            return typeObj[type]
        }
    },
    {
        title: '详情',
        dataIndex: 'data',
        key: 'data',
        render: (data) => {
            let type = data.type;
            const style = {
                display: 'block',
                height: 'auto',
                lineHeight: '30px',
                whiteSpace:'normal'
            };
            const style2 = {
                display: 'block',
                height: 'auto',
                lineHeight: '30px',
                marginLeft: 0
            };
            if (type == 'options') {
                return (
                    // <Radio.Group
                    //     options={data.detailData.options}
                    //     value={data.detailData.value}
                    // />
                    <Radio.Group
                        value={data.detailData.value}
                    >
                        {
                            data.detailData.options.map(item => (
                                <Radio value={ item.value } style={ style } >
                                    { item.label }
                                </Radio>
                            ))
                        }
                    </Radio.Group>
                )
            } else if (type == 'multiple') {
                return (
                    // <Checkbox.Group
                    //     options= {data.detailData.options}
                    //     value={data.detailData.value}
                    // />
                    <Checkbox.Group
                        value={ data.detailData.value }
                    >
                        {
                            data.detailData.options.map((item, index) => (
                                index != 0 ? 
                                <Checkbox value={ item.value } style={ style2 } >
                                    { item.label }
                                </Checkbox> :
                                <Checkbox value={ item.value } style={ style } >
                                    { item.label }
                                </Checkbox>
                            ))
                        }
                    </Checkbox.Group>
                )
            } else if (type == 'text') {
                return (
                    <div>
                        { decodeURI(data.detailData) }
                    </div>
                )
            } else if (type == 'moreinput') {
                return (
                    <div>
                        {
                            data.detailData.map((item) => (
                                <div style={{ marginBottom: 5 }}>
                                    <Input disabled addonBefore={item.name} value={item.value} />
                                </div>
                            ))
                        }
                        
                    </div>
                )
            } else if (type === 'select') {
                return (
                    <Select style={{minWidth: 100}} value={data.detailData.value}>
                        {
                            data.detailData.options.map((item) => (
                                <Select.Option value={item.value}>{item.label}</Select.Option>
                            ))
                        }
                    </Select>
                )
            } else if (type === 'belong') {
                return (
                    <div>{data.detailData}</div>
                )
            }
        }
    },
    {
        title: '分数',
        dataIndex: 'score',
        key: 'score',
        width: 80,
        render: (score) => {
            if (score == null || score == undefined) {
                return '无';
            }
            return score;
        }
    },
]

const querySearchById = () => {
    if(DataGrid.selections.length != 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项才能查看明细！',
        });
    } else {
        return fetch.get('surveystudentresult/get/' + DataGrid.selections[0])
        .then((response) => {
            if(response.code == 200) {
                return response.payload.data.map((item, index) => { 
                    item.key = index;
                    return item;
                 });
            }
        })
    }
}

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('surveystudentresult/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code == 200) {
            const columns = [
                {key:'$index', label: '序号'},
                {key:'batchNo', label: '批次', width: 150},
                {
                    key: 'objectTypeName',
                    label: '对象类型',
                    width: 120
                },
                {
                    key: 'objectName',
                    label: '对象名称',
                    width: 150
                },
                {key:'orgName', label: '部门', width: 150},
            ];
            if(response.payload.meta.extParams.academyOpen){
                columns.push({key:'academyName', label: '书院', width: 150});
            }
            columns.push({key:'surveyName', label: '问卷名称', width: 170});
            columns.push({key:'studentNo', label: '学号', width: 100});
            columns.push({key:'studentName', label: '学生姓名', width: 100});
            columns.push({key:'resultScore', label: '分数', width: 80});
            columns.push({key:'classesName', label: '班级名称', width: 100});
            columns.push({key:'classGrade', label: '年级'});
            columns.push({key:'evalTime', label: '提交时间', width: 150});
            columns.push({key:'termName', label: '所属学期/学年', width: 150});
            return {
                headers : utils.columns(columns),
                data: response.payload.data,
            }
        }
    }).then(res => (
        Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data || []).length ? '' : '暂无数据...'
        }))
    )
}

const batchRemove = (callback, loading) => {
    if(DataGrid.selections.length === 0) {
        Modal.confirm({
            title: '确认删除全部？',
            content: '没有选择数据，将删除当前学期全部数据',
            onOk: () => {
                Modal.confirm({
                    title: '再次确认是否删除全部数据？',
                    content: '点击确认删除当前学期全部数据',
                    onOk: () => {
                        loading();
                        remove([-1]).then(response => {
                            if(response.code === 200) {
                                message.success(response.message);
                                callback();
                            } else {
                                Modal.error({
                                    title: '消息',
                                    content: response.message,
                                    okText: '确认'
                                })
                            }
                        });
                    },
                    okText:"确认",
                    cancelText:"取消"
                })
            },
            okText:"确认",
            cancelText:"取消"
        });
    } else {
        Modal.confirm({
            title: '确定删除所选数据？',
            content: '删除后将无法恢复！',
            onOk() {
                loading();
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        callback();
                    } else {
                        Modal.error({
                            title: '消息',
                            content: response.message,
                            okText: '确认'
                        })
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

const remove = (ids) => {
    return fetch.post('surveystudentresult/delete', ids)
    .then(response => {
        onSelect([]);
        return response;
    }).catch(error => {
        return error;
    });
}

export default {
    headers,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    querySearch,
    batchRemove,
    detailColumns,
    querySearchById
}